import { createAction, props } from '@ngrx/store';

export const loadPacks = createAction(
  '[Packs] Load Packs'
);
export const loadPacksSuccess = createAction(
  '[Packs] Load Packs Success',
  props<{ packs: any[] }>()
);
export const loadPacksFailure = createAction(
  '[Packs] Load Packs Failure',
  props<{ error: any }>()
);
